import * as legends from '../config/legends'

const service = {
    name: 'IceDrift',
    label: 'Ice Drift',
    permissionId: 'iceDrift',
    iconComponent: 'SmartIce',
    showCoordinates: true,
    hideDatetimeSlider: true,
    data: [],
    layers: [
      {
        name: 'IceDrift',
        label: 'Ice Displacement',
        opacity: 'raster-opacity',
        datetimeId: 'IceDrift',
        exportId: 'IceDrift',
        hidden: true
      },
      {
        name: 'IceDriftVector',
        label: 'Ice Displacement',
        opacity: 'line-opacity',
        datetimeId: 'IceDrift',
        exportId: 'IceDrift',
        exportFormats: ['GEOTIFF', 'GEOJSON'],
        legend: {
            type: 'categorical',
            data: legends.iceDriftLegend
        },
      },
      {
        name: 'IceDriftVelocity',
        label: 'Ice Velocity',
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftVelocity',
        exportId: 'IceDriftVelocity',
        legend: {
          type: 'categorical',
          data: legends.iceDriftLegend
        },
      },
      {
        name: 'IceDriftDisplacement',
        label: 'Ice Feature Tracking',
        opacity: 'line-opacity',
        datetimeId: 'IceDriftDisplacement',
        exportId: 'IceDriftDisplacement',
        legend: {
            type: 'categorical',
            data: legends.iceDriftLegend
        },
      },
      {
        name: 'SmartIce',
        label: 'Ice travel',
        opacity: 'raster-opacity',
        datetimeId: 'SmartIce',
        exportId: 'SmartIceMaps',
        legend: {
          type: 'categorical',
          data: true ? legends.polarViewLegend : legends.smartIceLegend
        }
      },
      {
        name: 'Sentinel1SixMonth',
        label: 'Sentinel 1 (75 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1SixMonth',
        secondary: true
      },
      {
        name: 'Sentinel2SixMonth',
        label: 'Sentinel 2 (10 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2SixMonth',
        secondary: true
      },
      {
        name: 'ModisIceDrift',
        label: 'Modis (250 m)',
        opacity: 'raster-opacity',
        datetimeId: 'ModisIceDrift',
        secondary: true
      }
    ],
    locations: [
      // {
      //   name: 'IceDrift',
      //   label: 'Baffin Bay',
      //   latitude: 72.72476,
      //   longitude: -74.6495,
      //   zoom: [6]
      // },
      {
        name: 'Arctic',
        latitude: 73,
        longitude: -101,
        zoom: [3.5]
      },
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/IceDrift.js